export const camelToSentence = (str: string) => {
  const words = str.match(/(?:[A-Z][a-z]+|[0-9]+|[a-z]+)/g);
  if (!words) return str;

  const [firstWord, ...rest] = words;

  if (!firstWord.length) return str;

  return [firstWord[0].toUpperCase() + firstWord.slice(1), ...rest].join(" ");
};
